import { AlertContext } from "components/common/Alert";
import { useContext } from "react";

function useAlert() {
  return useContext(AlertContext);
}

export default useAlert;
